module.exports = __webpack_public_path__ + "img/banner-3-en.904fd692.png";